import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PageSettings } from "../../config/page-settings";
import "react-magic-slider-dots/dist/magic-dots.css";
import "react-multi-carousel/lib/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.css";
import Config from "../../Config.js";
import moment from "moment";
import axios from "axios";
import { postAbusereport } from "api/apiproductreport";
import swal from "sweetalert";
import Productdetailsfooter from "../productdetail/productdetailsfooter";
// import AddToCalendar from 'react-add-to-calendar';
// import LoadingSpinner from '../Loder/LoadingSpinner'

const Detail = () => {
  const location = useLocation().search;
  const locationPath = window.location.href;
  let history = useHistory();
  const mapId = new URLSearchParams(location).get("mapId");
  const rendername = new URLSearchParams(location).get("render");
  const ProductType = new URLSearchParams(location).get("maptarget");
  const StaticDetails = new URLSearchParams(location).get("Static");
  console.log("StaticDetails=>", mapId);
  console.log("StaticDetailsDFDS=>", rendername);
  console.log("StaticDetails=>", ProductType);
  console.log("StaticDetailsDFDS=>", StaticDetails);
  const [sharehidePass, setshareHidePass] = useState(true);
  const [wallethidePass, setwalletHidePass] = useState(true);
  const [qrhidePass, setqrhidePass] = useState(true);
  const context = useContext(PageSettings);
  const [isLoading, setisLoading] = useState(false);
  const [IsPublished, setIsPublished] = useState(true);
  const [productinfo, setproductinfo] = useState(null);

  const [isfirstloding, setisfirstloding] = useState(false);

  const [BrandingLogoPath, setBrandingLogoPath] = useState("");
  const [WhiteLabellingName, setWhiteLabellingName] = useState("");

  const [SelectTypeofabuse, setSelectTypeofabuse] = useState("Nudity");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [modalReportabuse, setmodalReportabuse] = useState(false);

  const [isPublishedBarding, setisPublishedBarding] = useState(false);
  const [isPublishedTagLine, setisPublishedTagLine] = useState(false);

  // const [events, setEvents] = useState([]);
  console.log("productinfo=>", productinfo);
  // let event = {
  //     title: 'Sample Event',
  //     description: 'This is the sample event provided as an example only',
  //     location: 'Portland, OR',
  //     startTime: '2016-09-16T20:15:00-04:00',
  //     endTime: '2016-09-16T21:45:00-04:00'
  // }
  // let items = [
  //     { google: 'Google' }
  // ];
  // let icon = { 'calendar-plus-o': 'left' };
  useEffect(() => {
    console.log("component mounted");
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    context.handleSetpagecontainer(false);
    // return a function to execute at unmount
    return () => {
      console.log("component will unmount");
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetpagecontainer(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []); // notice the empty array

  useEffect(() => {
    getBrandingLogoandWhiteLabelling(ProductType, rendername, mapId);
  }, [mapId]);

  const getBrandingLogoandWhiteLabelling = async (
    productType,
    renderName,
    MapId
  ) => {
    if (
      productType !== null &&
      productType !== "" &&
      productType !== undefined &&
      MapId !== "" &&
      MapId !== null &&
      MapId !== undefined &&
      renderName !== "" &&
      renderName !== undefined &&
      renderName !== null
    ) {
      setTimeout(() => {
        setisfirstloding(true);
      }, 300);

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/GetBrandingLogoandWhiteLabelling?id=" +
        MapId +
        "&rendername=" +
        renderName +
        "&ProductType=" +
        productType +
        "&Latitude=",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setisLoading(true);
          setisPublishedBarding(responseJson?.isPublishedBarding ? responseJson?.isPublishedBarding : false);
          setisPublishedTagLine(responseJson?.isPublishedTagLine ? responseJson?.isPublishedTagLine : false);
          if (
            responseJson?.brandingLogo !== null &&
            responseJson?.brandingLogo !== "" &&
            responseJson?.brandingLogo !== undefined
          ) {
            setBrandingLogoPath(Config.contentUrl + responseJson?.brandingLogo);
          } else {
            setBrandingLogoPath("");
          }

          setWhiteLabellingName(responseJson?.labellingName);

          // setTimeout(() => {
          //   setisfirstloding(false);
          // }, 300);
          setisfirstloding(false);


          GetAllProductInfo(mapId);

        })
        .catch((error) => {
          console.log(error);
          setisfirstloding(false);
          // setTimeout(() => {
          //   setisfirstloding(false);
          // }, 300);
        });
    }
    // setisLoading(false);
  };

  // useEffect(() => {
  //     updateTotalScans(ProductType, rendername, mapId)
  // }, [mapId]);
  const updateTotalScans = async (productType, renderName, MapId) => {
    if (
      productType !== null &&
      productType !== "" &&
      productType !== undefined &&
      MapId !== "" &&
      MapId !== null &&
      MapId !== undefined &&
      renderName !== "" &&
      renderName !== undefined &&
      renderName !== null
    ) {
      setisLoading(true);
      const res = await axios.get("https://geolocation-db.com/json/");
      if (res !== null) {
        fetch(
          Config.apiUrl +
          "QRCodeScanHistory/updateTotalScans?id=" +
          MapId +
          "&rendername=" +
          renderName +
          "&ProductType=" +
          productType +
          "&Latitude=" +
          res?.data?.latitude +
          "&Longitude=" +
          res?.data?.longitude,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((responseJson) => {
            console.log("responseJson=>", responseJson);
          })
          .catch((error) => {
            setisLoading(false)
            console.log(error);
          });
      }
    }
    // setisLoading(false)
  };
  // useEffect(() => {
  //   GetAllProductInfo(mapId);
  // }, [mapId]);
  const GetAllProductInfo = async (articleidObj) => {
    setisLoading(true);
    if (
      articleidObj != null &&
      articleidObj != "" &&
      articleidObj != undefined
    ) {
      // let loginid = localStorage.getItem("loginUserID");
      await fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodeQrCodeResourceWithOutUserCompanyId?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // "userCompanyID": loginid,
          },
        }
      )
        .then((resp1) => {
          resp1.json().then((result) => {
            if (result._id != null) {
              if (result?.isMobileApp === false) {
                updateTotalScans(ProductType, rendername, mapId);
              }

              if (result.qrCodeType === "URL" && result?.isPublished === true) {
                let url = result?.website;
                if (!url.match(/^https?:\/\//i)) {
                  url = "http://" + url;
                }
                window.location.href = url;
              } else {
                // setisLoading(false);
                setTimeout(() => {
                  setisLoading(false);
                }, 3000);
                setIsPublished(result?.isPublished ? result?.isPublished : false);
                setproductinfo(result);
              }
            }
          });
        })
        .catch((error) => {
          setisLoading(false);
          console.log("error", error);
        });
    } else {
      setisLoading(false);
    }
  };
  const GotoHome = () => {
    history.push({
      pathname: "/home",
    });
  };
  const OpenExternalURL = (URL) => {
    let url = URL;
    if (!url.match(/^https?:\/\//i)) {
      url = "http://" + url;
    }
    window.open(url);
  };
  const OpenExternallink = (QrCodeType, String) => {
    if (QrCodeType === "URL") {
      let url = productinfo.website;
      if (!url.match(/^https?:\/\//i)) {
        url = "http://" + url;
      }
      window.open(url);
    } else if (QrCodeType === "Email") {
      let url = `mailto:${productinfo.email}?subject=${productinfo.subject}&body=${productinfo.desctiption}`;
      window.open(url);
    } else if (QrCodeType === "Phone") {
      let url = `tel:${productinfo.phoneNo}`;
      window.open(url);
    } else if (QrCodeType === "SMS") {
      let url = `sms:${productinfo.phoneNo}?body=${productinfo.desctiption}`;
      window.open(url);
    } else if (QrCodeType === "Calendar") {
      let startdate = moment
        .utc(productinfo.startDate)
        .format("YYYYMMDDTHHmmssSSS[Z]");
      let EndDate = moment
        .utc(productinfo.endDate)
        .format("YYYYMMDDTHHmmssSSS[Z]");
      window.open(
        `https://calendar.google.com/calendar/r/eventedit?dates=${startdate}/${EndDate}&location=${productinfo.location}&text=${productinfo.subject}&details=${productinfo.desctiption}`
      );
    } else if (QrCodeType === "Wifi") {
    } else if (QrCodeType === "MyQR") {
      if (String === "call") {
        let url = `tel:${productinfo.phoneNo}`;
        window.open(url);
      } else if (String === "email") {
        let url = `mailto:${productinfo.email}?subject=${productinfo.subject
          }&body=${""}`;
        window.open(url);
      }
    }
  };
  const AddContact = () => {
    let url = `https://contacts.google.com/new?email=${productinfo.email}&phone=${productinfo.phoneNo}`;
    window.open(url);
  };

  const LoaderSpinner = () => {
    return (
      <div className="vh-100" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="">
          <img src="../assets/img/LOADINGSCREEN-removebg.png" className="loaderimg" style={{ height: '700px' }}></img>
        </div>
      </div>
      // <div className="spinner-container">
      //   <div className="loading-spinner"></div>
      // </div>
    );
  };
  const toggleReportabuse = () => {
    setSelectTypeofabuse("Nudity")
    setmodalReportabuse(false);
  };

  const SendAbusereport = async () => {
    let repostvalue = {
      "abusereportTypes": SelectTypeofabuse,
      "loginEmail": "",
      "productlink": locationPath ? locationPath.toString() : "",
      "latitude": latitude ? latitude.toString() : "",
      "longitude": longitude ? longitude.toString() : ""
    }
    console.log("JSON.stringify(repostvalue)=====>", JSON.stringify(repostvalue))
    await postAbusereport(JSON.stringify(repostvalue))
      .then((res) => {
        console.log("res.data:", res)
        if (res === true || res === "true") {
          toggleReportabuse();
          swal('Thanks!', "Your report has been submitted .", {
            icon: "success",
          });
        }
        else {
          swal('error!', "Your report has been not submitted.", {
            icon: "error",
          });
        }
      })
      .catch((err) => {
        swal('error!', err, {
          icon: "error",
        });
        console.log(err)
      })
  }
  const iOSUrl =
    "https://itunes.apple.com/us/app/all-of-the-lights/id959389722?mt=8";
  const androidUrl = "https://play.google.com";
  return (
    <>
      {/* {isfirstloding && LoaderSpinner()} */}
      {isfirstloding === false && isLoading === true ? (
        <>
          <div className="splashbg-change vh-100">
            <div className="logoimgcontainer">
              {/* <img
                src="/assets/img/logo/Logo _S.jpg"
                style={{ height: "80px" }}
              /> */}
              {BrandingLogoPath !== null &&
                BrandingLogoPath !== "" &&
                BrandingLogoPath !== undefined && isPublishedBarding === true ? (
                <img
                  src={BrandingLogoPath}
                  className="sttlogo"
                  style={{ height: "80px" }}
                />
              ) : (
                // <img
                //   src="../assets/img/logo/Logo_S.jpg"
                //   style={{ height: "80px" }}
                // />
                // <img src="../assets/img/LOADINGSCREEN-removebg.png" className="sttlogo" style={{ height: "80px" }}></img>
                <div className="container-fluid">
                  <div className="loadernew">
                    <h2>Wait Please</h2>
                    {/* <img src="../assets/img/loading.gif" className="gif" /> */}
                    <img src="../assets/img/loadingblack.gif" className="gif" />
                    <div className="logo">
                      <img src="../assets/img/logo/STT-Logo.png" width="20px" height="20px" />
                      <p >STT</p>
                    </div>
                  </div>
                </div>

              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="bg-change pb-5" style={{ position: 'relative', minHeight: '100vh' }}>
            <div className="padding-30">
              <div className="container detailpageheader">
                <div className="row align-items-center px-2">

                  {WhiteLabellingName !== null &&
                    WhiteLabellingName !== "" &&
                    WhiteLabellingName !== undefined && isPublishedTagLine === true ? (
                    <h4 className="col-xs-6 mb-0">{WhiteLabellingName}</h4>
                  ) : (
                    <h4 className="col-xs-6 mb-0">Scan To Tell</h4>
                  )}
                  <div
                    className="col-xs-6 d-flex align-items-end justify-content-end"
                  // onClick={() => { GotoHome() }}
                  >
                    {/* <img
                      src="../assets/img/logo/Logo _S.jpg"
                      className="sttlogo"
                    />
                    <h4 className="mb-0 ml-1">STT</h4> */}
                    {BrandingLogoPath !== null && BrandingLogoPath !== "" && BrandingLogoPath !== undefined && isPublishedBarding === true ? (
                      <img src={BrandingLogoPath} className="sttlogo" />
                    ) : (
                      <img
                        alt=""
                        src="../assets/img/logo/Logo_S.jpg"
                        className="sttlogo"
                      />
                      // <img src="../assets/img/LOADINGSCREEN-removebg.png" className="sttlogo"></img>
                    )}
                  </div>
                </div>
              </div>
              {(IsPublished === true && productinfo !== null && productinfo !== "" && productinfo !== undefined) ? (
                <>
                  <div className="container-fluid pt-4">
                    {productinfo?.qrCodeType === "URL" ? (
                      <div className="row align-items-center text-break">
                        <div className="col-xs-12">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-info"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <a href={productinfo?.website} target="_blank">
                                <h6 className="mb-1 text-blue align-self-center">
                                  {productinfo?.website}
                                </h6>
                              </a>
                              <small>URL</small>
                            </div>
                          </div>
                          {/* <h3 className='mb-1  align-self-center'>URL :</h3>
                                                    <a href={productinfo.website} target="_blank"><h4 className='mb-1 text-blue align-self-center'>{productinfo.website}</h4></a> */}
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "Text" ? (
                      <div className="row d-flex align-items-center " style={{ wordBreak: 'break-all' }}>
                        <div className="col-xs-12  ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-info"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo.desctiption}</h6>
                              <small>About</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "Email" ? (
                      <div className="row d-flex align-items-center">
                        <div className="col-xs-12 ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-envelope"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.email}</h6>
                              <small>Email</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-file"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.subject}</h6>
                              <small>Subject</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-info"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.desctiption}</h6>
                              <small>About</small>
                            </div>
                          </div>
                          {/* <h3 className='mb-1  align-self-center'>Subject :</h3>
                                                            <h4 className='mb-1 text-black align-self-center'>{productinfo.subject}</h4>
                                                            <h3 className='mb-1  align-self-center'>About :</h3>
                                                            <h4 className='mb-1 text-black align-self-center'>{productinfo.desctiption}</h4> */}
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "Phone" ? (
                      <div className="row align-items-center">
                        <div className="col-xs-12 ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-phone"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.phoneNo}</h6>
                              <small>Phone No</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "SMS" ? (
                      <div className="row d-flex align-items-center">
                        <div className="col-xs-12 ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-phone"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.phoneNo}</h6>
                              <small>Phone No</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-info"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.desctiption}</h6>
                              <small>Description</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "Wifi" ? (
                      <div className="row d-flex align-items-center pb-3">
                        <div className="col-xs-12  ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-user"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.subject}</h6>
                              <small>Network Name</small>
                            </div>
                          </div>
                          {productinfo?.wifiTypeDetail?.name !==
                            "No Password" && (
                              <div className="icon-row">
                                <div className="icon-row-container">
                                  {productinfo?.isPasswordShow === true ? (
                                    <i className="fas fa-eye"></i>
                                  ) : (
                                    <i className="fas fa-eye-slash"></i>
                                  )}
                                </div>
                                <div className="icon-row-name-container">
                                  {productinfo?.isPasswordShow === true ? (
                                    <h6>{productinfo?.password}</h6>
                                  ) : (
                                    <h6>********</h6>
                                  )}
                                  <small>Password</small>
                                </div>
                              </div>
                            )}

                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-wifi"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.wifiTypeDetail?.name}</h6>
                              <small>WiFi Type</small>
                            </div>
                          </div>
                         
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "Calendar" ? (
                      <div className="row align-items-center">
                        <div className="col-xs-12  ">
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-user"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo?.subject
                                  ? productinfo?.subject
                                  : "N/A"}
                              </h6>
                              <small>Name</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-calendar"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo?.startDate
                                  ? moment(productinfo?.startDate).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "N/A"}
                              </h6>
                              <small>Start Date</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-calendar"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo?.endDate
                                  ? moment(productinfo?.endDate).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "N/A"}
                              </h6>
                              <small>End Date</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-map-pin"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo?.location}</h6>
                              <small>Location</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-file"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo.desctiption}</h6>
                              <small>Description</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : productinfo?.qrCodeType === "MyQR" ? (
                      <div className="row align-items-center pb-3">
                        <div className="col-xs-12">
                          <div className="d-flex justify-content-center">
                            <div>
                              {productinfo.imagePath !== null &&
                                productinfo.imagePath !== undefined &&
                                productinfo.imagePath !== "" &&
                                productinfo.image_id !== "" &&
                                productinfo.image_id !== undefined &&
                                productinfo.image_id !== null ? (
                                <img
                                  src={
                                    Config.contentUrl + productinfo?.imagePath
                                  }
                                  className="MyQrOwnerImage shadow-add"
                                />
                              ) : (
                                // <img
                                //   src="../assets/img/noimage.jpg"
                                //   className="MyQrOwnerImage shadow-add"
                                // />
                                <></>
                              )}
                            </div>
                          </div>
                          <div className="pb-4 pt-2">
                            <div className="qrcoderowbutton">
                              <button
                                type="button"
                                class="btn btn-success shadow-add d-flex"
                                style={{
                                  backgroundColor: wallethidePass
                                    ? "#15a476"
                                    : "#15a476",
                                  color: wallethidePass ? "#fff" : "#fff",
                                }}
                                onClick={() => {
                                  OpenExternallink(
                                    productinfo.qrCodeType,
                                    "call"
                                  );
                                }}
                              >
                                <i class="ion ion-ios-call fa-2x fa-fw iconheight"></i>
                                <p className="mb-0 subcollapse">Call</p>
                              </button>
                              <button
                                type="button"
                                class="btn btn-success shadow-add  d-flex"
                                style={{
                                  backgroundColor: wallethidePass
                                    ? "#15a476"
                                    : "#15a476",
                                  color: wallethidePass ? "#fff" : "#fff",
                                }}
                                onClick={() => {
                                  OpenExternallink(
                                    productinfo.qrCodeType,
                                    "email"
                                  );
                                }}
                              >
                                <i class="ion ion-ios-mail fa-2x fa-fw iconheight"></i>
                                <p className="mb-0 subcollapse">Email</p>
                              </button>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-user"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo.subject ? productinfo.subject : ""}
                              </h6>
                              <small>Name</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-users"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo.organization
                                  ? productinfo.organization
                                  : ""}
                              </h6>
                              <small>Organization</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-map-pin"></i>
                            </div>
                            <div className="icon-row-name-container">
                              {productinfo?.address ? (
                                <h6>
                                  {productinfo?.address
                                    ? productinfo?.address
                                    : ""}
                                </h6>
                              ) : (
                                <h6>
                                  {productinfo.houseNo
                                    ? productinfo.houseNo + " , "
                                    : ""}
                                  {productinfo.city
                                    ? productinfo.city + " , "
                                    : ""}
                                  {productinfo.street ? productinfo.street + ' , ' : ""}
                                  {productinfo.postcode ? productinfo.postcode : ""}
                                </h6>
                              )}

                              <small>Address</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-phone"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo.phoneNo ? productinfo.phoneNo : ""}
                              </h6>
                              <small>Phone No</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-phone"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo.officeNo
                                  ? productinfo.officeNo
                                  : ""}
                              </h6>
                              <small>Office No</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-envelope"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>
                                {productinfo.email ? productinfo.email : ""}
                              </h6>
                              <small>Email</small>
                            </div>
                          </div>
                          <div className="icon-row">
                            <div className="icon-row-container">
                              <i className="fas fa-info"></i>
                            </div>
                            <div className="icon-row-name-container">
                              <h6>{productinfo.desctiption}</h6>
                              <small>About</small>
                            </div>
                          </div>
                          {productinfo?.externalLink.length > 0 ? (
                            productinfo?.externalLink?.map((item) => (
                              <div className="linkmain-btn mb-2">
                                <h5 className="btn mb-0">
                                  {item?.name ? item?.name : "N/A"}
                                </h5>
                                <button
                                  className="btn btn-link weblinkbuton"
                                  type="button"
                                  onClick={() => {
                                    OpenExternalURL(item?.linkURL);
                                  }}
                                >
                                  <p className="mb-0 exploreweblink text2line">
                                    {item?.linkURL}
                                  </p>
                                  <button className="btn bg-darkgreen btn-icon btn-circle btn-lg m-r-2">
                                    <i className="ion ion-md-copy"></i>
                                  </button>
                                </button>
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                         
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  {productinfo?.qrCodeType === "Text" ||
                    productinfo?.qrCodeType === "MyQR" ||
                    productinfo?.qrCodeType === "Wifi" ? (
                    <></>
                  ) : (
                    <div className="container-fluid ">
                      <div className="rowbuttons pb-4 pt-2">
                        <div className="">
                          <button
                            type="button"
                            class="btn btn-white shadow-add"
                            style={{
                              backgroundColor: wallethidePass
                                ? "#fff"
                                : "#05A473",
                              color: wallethidePass ? "#05A473" : "#fff",
                            }}
                            onClick={() => {
                              OpenExternallink(productinfo?.qrCodeType);
                            }}
                          >
                            <i class="ion ion-ios-folder-open fa-2x fa-fw iconheight"></i>
                            <p className="mb-0 subcollapse">Open</p>
                          </button>
                        </div>
                        {/* <div style={{ height: '100%', width: '100%' }}> */}
                        {/* <AddToCalendar event={event} listItems={items}buttonTemplate={icon} buttonLabel="" optionsOpen={true} /> */}
                        {/* </div> */}
                        {/* <div className=''>
                                                <button
                                                    type="button"
                                                    class="btn btn-white shadow-add"
                                                    style={{
                                                        backgroundColor: sharehidePass ? '#fff' : "#888888",
                                                        color: sharehidePass ? '#888888' : "#fff"
                                                    }}
                                                    onClick={() => setshareHidePass(!sharehidePass)}>
                                                    <i class="ion ion-md-share fa-2x fa-fw iconheight"></i>
                                                    <p className='mb-0 subcollapse'>Share</p>
                                                </button>
                                            </div>
   <div className=''>
                                                <button
                                                    type="button"
                                                    class="btn btn-white shadow-add"
                                                    style={{
                                                        backgroundColor: qrhidePass ? '#fff' : "#000",
                                                        color: qrhidePass ? '#000' : "#fff"
                                                    }}
                                                    onClick={() => setshareHidePass(!sharehidePass)}>
                                                    <i class="fas  fa-qrcode fa-2x fa-fw iconheight"></i>
                                                    <p className='mb-0 subcollapse'>Qr Code</p>
                                                </button>
                                            </div> */}
                      </div>
                    </div>
                  )}
                  {productinfo?.qrCodeType === "MyQR" ? (
                    // <a href="#" class="btn right-corner-btn">
                    //     <i class="fas fa-user-plus"></i>
                    // </a>
                    <button
                      type="button"
                      class="btn right-corner-btn"
                      onClick={() => {
                        AddContact(productinfo?.qrCodeType);
                      }}
                    >
                      <i class="fas fa-user-plus"></i>
                    </button>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                (IsPublished === false && isLoading === false && isfirstloding === false) && (
                  <div className="container" >
                    <div className="splashbg-change d-flex justify-content-center" style={{ position: 'relative', }}>
                      <div className="">
                        <p className="bold m-t-10 h3 mx-2">
                          Sorry the owner has stop the publishing
                        </p>
                        <img
                          src="../assets/img/STT_UnPublish-removebg-preview.png"
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
            <Productdetailsfooter
              onClick={(e) => {
                setmodalReportabuse(true)
              }}

            ></Productdetailsfooter>
          </div>
        </>
      )}

      <Modal
        isOpen={modalReportabuse}
        toggle={toggleReportabuse}
        className="text-center modalcenter mx-5"
      >
        <ModalBody>
          <div className="">
            <div className="modal-typeofabuse">
              <p className="mx-2">
                Type of abuse
              </p>

              <div className="radio " onClick={() => { setSelectTypeofabuse("Nudity") }}>

                <input
                  type="radio"
                  value="Nudity"
                  checked={SelectTypeofabuse === "Nudity"}
                  onChange={() => { setSelectTypeofabuse("Nudity") }}
                />
                <label className="mr-2">
                  Nudity
                </label>
              </div>
              <div className="radio" onClick={() => { setSelectTypeofabuse("Copyright infringement") }}>

                <input
                  type="radio"
                  value="Copyright infringement"
                  checked={SelectTypeofabuse === "Copyright infringement"}
                  onChange={() => { setSelectTypeofabuse("Copyright infringement") }}
                />
                <label className="mr-2">
                  Copyright infringement
                </label>
              </div>
              <div className="radio" onClick={() => { setSelectTypeofabuse("Spam, malware or phishing") }}>

                <input
                  type="radio"
                  value="Spam, malware or phishing"
                  checked={SelectTypeofabuse === "Spam, malware or phishing"}
                  onChange={() => { setSelectTypeofabuse("Spam, malware or phishing") }}
                />
                <label className="mr-2">
                  Spam, malware or phishing
                </label>
              </div>
              <div className="radio" onClick={() => { setSelectTypeofabuse("Hate, violence or illegal content") }}>
                <input
                  type="radio"
                  value="Hate, violence or illegal content"
                  checked={SelectTypeofabuse === "Hate, violence or illegal content"}
                  onChange={() => { setSelectTypeofabuse("Hate, violence or illegal content") }}
                />
                <label className="mr-2">
                  Hate, violence or illegal content
                </label>
              </div>
              <button
                type="button"
                onClick={() => {
                  SendAbusereport();
                }}
                class="btn btn-primary shadow-add btn-sm"
              >
                <p className="mb-0 subcollapse">
                  Submit report
                </p>
              </button>
            </div>
            <button
              className="btn btn-link modalcolsebtn"
              onClick={() => { toggleReportabuse() }}
            >
              <i className="ion ion-md-close-circle fa-2x"></i>
            </button>
            <div lassName="container-fluid ">
              <div className="row justify-content-center mt-3 flex-wrap">
                <a href={"https://qrcode-stt.com/"}
                  target="_blank"
                  name={"Report abuse"}
                  className={"btn btn-link"}
                >
                  {"STT"}
                </a>
                <a href={"https://qrcode-stt.com/privacy-policy"} target="_blank"
                  name={"Terms of Service"}
                  className={"btn btn-link"}
                >
                  {"Privacy Policy"}
                </a>
                <a href={"https://qrcode-stt.com/contact-us"}
                  target="_blank"
                  name={"Help"}
                  className={"btn btn-link"}
                >
                  {"Help"}
                </a>

              </div>
            </div>
          </div>

        </ModalBody>
      </Modal>
    </>
  );
};

export default Detail;
